import BangKeoKQ from "../BangKeoKQ";

const KbvBangKeoKetQuaV2 = () => {
  return <BangKeoKQ type="ketqua" />
};

export default KbvBangKeoKetQuaV2;

